import request from '@/core/request'
import { ref, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'

export const defaultConfig = {
  key: 'ui-date-picker1', // 每个ui组件必须有
  type: 'ui-date-picker1', //
  images: {
    datePickerBg: 'date-picker-bg',
  }, // 每个组件的配置都统一放到images中管理
  layout: {
    wrapper: {
      datePickerWrapper: {
        pz: '10',
        f: '13 #8D190C 400',
        m: '0 auto',
      },
      datePickerTodayWrapper: {
        pl: '12',
        pc: 'y',
      },
      datePickerListWrapper: {
        wh: '74 102',
        bgC: '#fff',
        bdr: '7',
        pc: 'x',
        pt: '26',
      },
      datePickerItemWrapper: {
        wh: '74 34',
        p: 'relative',
      },
      datePickerShowWrapper: {
        wh: '30 100%',
        pr: '0',
      },
    },
  },
  config: {
    datePickerListApi: '/api/activities/general/schedule/info',
  }, //每个ui组件的一些配置字段相关的东西
}

export const useDatePicker = (uiMeta: any) => {
  const route = useRoute()
  const router = useRouter()
  const activity_code = route.meta?.activity_code
  const todayDate = dayjs().format('YYYY-MM-DD')
  const isShowDateList = ref(false)
  const currentDate = ref(todayDate)

  const { data: datePickerListData, refetch: refetchDatePickerList } = useQuery({
    queryKey: ['datePickerList'],
    queryFn: async () => {
      return await request.get(uiMeta.config.datePickerListApi, {
        activity_code: activity_code,
      })
    },
  })

  const handleShowDateList = () => {
    isShowDateList.value = !isShowDateList.value
  }

  const handleDateClick = (item: string) => {
    console.log('handleDateClick', item)
    isShowDateList.value = false
    currentDate.value = item
    // 在路由上面带上参数
    router.push({
      path: route.path,
      query: {
        ...route.query,
        rank_date: item,
      },
    })
  }

  const computedDatePickerListData = computed(() => {
    return datePickerListData.value?.data?.dates || []
  })

  return {
    datePickerListData: computedDatePickerListData,
    refetchDatePickerList,
    todayDate,
    isShowDateList,
    currentDate,
    handleShowDateList,
    handleDateClick,
  }
}
